var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-jigou",style:({ width: _vm.width + 'px' })},[_c('el-cascader',{attrs:{"options":_vm.options,"props":{
      checkStrictly: true,
      label: '名称',
      value: 'institution_id',
      children: 'sub_institutions',
      emitPath: false,
    },"clearable":"","size":"small","placeholder":_vm.placeholder,"show-all-levels":false},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }